import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";
import CustomSelectMultiple from "../../globalno-dodavanje/CustomSelectMultiple";
import CustomCalendarInput from "../../evidencije/CustomCalendarInput";
import axios from "axios";

const formatDateForApi = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.replace(/\.$/, "").split(".");
  if (parts.length < 3) return null;
  const year =
    parts[2].length === 2
      ? (parseInt(parts[2]) < 50 ? "20" : "19") + parts[2]
      : parts[2];
  return `${year}-${parts[1]}-${parts[0]}`;
};

function AzuriranjeDokumenta({ dokument, cancel, onRefresh }) {
  const [form, setForm] = useState({
    naziv: "",
    broj_dokumenta: "",
    datum: "",
    zaposleni: [],
    radna_mesta: [],
  });
  const [zaposleniAll, setZaposleniAll] = useState([]);
  const [radnaMestaAll, setRadnaMestaAll] = useState([]);

  const { selectedMainEntity, baseUrl, dictionary } = useGlobalContext();

  useEffect(() => {
    if (dokument) {
      setForm({
        naziv: dokument.naziv || "",
        broj_dokumenta: dokument.broj_dokumenta || "",
        datum: dokument.datum || "",
        zaposleni: dokument.zaposleni || [],
        radna_mesta: dokument.radna_mesta || [],
      });
    }
  }, [dokument]);

  useEffect(() => {
    const fetchLookups = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/evidencija1/get_lookups.php`,
          {
            company_id: selectedMainEntity.company_id,
          },
        );
        if (data.status === 200) {
          setZaposleniAll(
            data.zaposleni.map((z) => ({ id: z.employee_id, name: z.name })),
          );
          setRadnaMestaAll(
            data.radna_mesta.map((r) => ({ id: r.id, name: r.name })),
          );
        }
      } catch (e) {
        console.error(e);
      }
    };
    if (selectedMainEntity?.company_id) fetchLookups();
  }, [selectedMainEntity]);

  const onChange = (value, field) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  const onChangeMultiple = (value, field) => {
    const current = form[field];
    const exists = current.find((d) => d.id === value.id);
    const newVals = exists
      ? current.filter((d) => d.id !== value.id)
      : [...current, value];
    setForm((prev) => ({ ...prev, [field]: newVals }));
  };

  const handleSave = async () => {
    try {
      const payload = {
        id: dokument.id,
        naziv: form.naziv,
        broj_dokumenta: form.broj_dokumenta,
        datum: formatDateForApi(form.datum),
        zaposleni: form.zaposleni,
        radna_mesta: form.radna_mesta,
      };
      const { data } = await axios.post(
        `${baseUrl}/lzo_dokumenta/update.php`,
        payload,
      );
      if (data.status === 200) {
        onRefresh();
        cancel();
      }
    } catch (e) {
      console.error(e);
    }
  };

  const isDisabled =
    !form.naziv || form.zaposleni.length === 0 || form.radna_mesta.length === 0;

  return (
    <div
      style={{ padding: "20px", fontSize: "14px", backgroundColor: "#F9F9F9" }}
    >
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "flex-end",
          flexWrap: "wrap",
        }}
      >
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "13px",
              marginBottom: "4px",
            }}
          >
            NAZIV
          </div>
          <input
            value={form.naziv}
            onChange={(e) => onChange(e.target.value, "naziv")}
            style={{
              height: "40px",
              padding: "0 8px",
              fontSize: "14px",
              width: "200px",
            }}
          />
        </div>
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "13px",
              marginBottom: "4px",
            }}
          >
            BROJ DOKUMENTA
          </div>
          <input
            value={form.broj_dokumenta}
            onChange={(e) => onChange(e.target.value, "broj_dokumenta")}
            style={{
              height: "40px",
              padding: "0 8px",
              fontSize: "14px",
              width: "150px",
            }}
          />
        </div>
        <div>
          <CustomCalendarInput
            value={form.datum}
            onChange={(v) => onChange(v, "datum")}
            label="DATUM"
          />
        </div>
        <div style={{ width: "200px" }}>
          <CustomSelectMultiple
            label="IME I PREZIME"
            allValues={zaposleniAll}
            selectedValues={form.zaposleni}
            onSelectChange={(v) => onChangeMultiple(v, "zaposleni")}
          />
        </div>
        <div style={{ width: "200px" }}>
          <CustomSelectMultiple
            label="RADNO MESTO"
            allValues={radnaMestaAll}
            selectedValues={form.radna_mesta}
            onSelectChange={(v) => onChangeMultiple(v, "radna_mesta")}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <div onClick={cancel}>
          <Button activation={true} style={{ padding: "10px" }}>
            ODUSTANI
          </Button>
        </div>
        <div
          onClick={isDisabled ? undefined : handleSave}
          style={{ opacity: isDisabled ? 0.5 : 1 }}
        >
          <Button
            isDisabled={isDisabled}
            activation={true}
            style={{ padding: "10px" }}
          >
            SAČUVAJ
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AzuriranjeDokumenta;
